import React from "react";
import { useEffect, useState, useContext } from "react";
import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import RowPost from "../components/RowPost/RowPost";
import {

  originals,
  trending,
  comedy,
  horror,
  Adventure,
  SciFi,
  Animated,
  War,
  trendingSeries,
  UpcomingMovies,
} from "../Constants/URLs";
import { AuthContext } from "../Context/UserContext";
import Navbar from "../components/Header/Navbar";
import { Navigate } from "react-router-dom";
import axiosClient from "../axios-client";
import RowPostTest from "../components/RowPost/RowPostTest";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Home() {
  const { user, profileId } = useContext(AuthContext);
  const [watchedMovies, setWatchedMovies] = useState([]);
  const [content, setContent] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosClient.get("/categories/with-content/");
        setCategories(response.data);
      } catch (error) {
        // console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);
  const fetchContentData = async () => {
    try {
      setIsLoading(true);

      const response = await axiosClient.get(`watch-history/profile/${profileId}/?page=${1}&page_size=${9999}`);

      setContent(response.data.results);

      setIsLoading(false);
    } catch (error) {
      // console.error("Error fetching the content data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true)
    fetchContentData();
  }, [profileId]);

  if (!profileId) {
    return <Navigate to="/profile" replace />;
  }


  return (
    <div>
      <ToastContainer />
      <Navbar></Navbar>
      <Banner></Banner>
      <div className="mb-20 w-[99%] ">
        
        <RowPost isNew title="Nouveautés" url={2}></RowPost>
        {content.length>0 && 
                <RowPost WatchHistory title="Continuer la lecture" ></RowPost>
}
        {categories.map((category) => (
          <div key={category.id}>
            <RowPost islarge={category.name === "Originals Maya+"} title={category.name} url={category.id}></RowPost>
          </div>
        ))}

        <RowPost isSerie title="Séries" url={""}></RowPost>

      </div>
      {/* <div className="mt-5 w-[99%] ">

        <RowPostTest first title="Continuer la lecture" url={trending}></RowPostTest>
        <RowPostTest title="Nouveautés" url={UpcomingMovies}></RowPostTest>
        <RowPostTest title="Fictions" url={SciFi}></RowPostTest>

        <RowPostTest
          title="Originals Maya+"
          islarge
          url={originals}
          key={originals}
        ></RowPostTest>
        <RowPostTest title="Documentaires" url={comedy}></RowPostTest>
        <RowPostTest title="Jeunesse" url={Adventure}></RowPostTest>
        <RowPostTest title="Courts métrages" url={horror}></RowPostTest>
        <RowPostTest isSerie title="Séries" url={trendingSeries}></RowPostTest>
      </div> */}
      <Footer></Footer>
    </div>
  );
}

export default Home;
